// extracted by mini-css-extract-plugin
export default {"milestone":"About_milestone__L4pBZ"};